import { useCallback, useEffect } from "react";
import {
  Container,
  Row,
  Form,
  FloatingLabel,
  Button,
  Spinner,
  Image,
} from "react-bootstrap";
import { SubmitHandler, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import styles from "./forgotPasswordPage.module.scss";
import forgotPasswordPageSlice from "./store/slice";
import Logo from "../../images/logo-colour.svg";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";

export type ForgotPasswordFormValues = {
  email: string;
};

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.forgotPasswordPage.isLoading);
  const requestSent = useSelector(
    (state) => state.forgotPasswordPage.requestSent
  );

  const sendRequest = useCallback(
    (data: ForgotPasswordFormValues) =>
      dispatch(forgotPasswordPageSlice.actions.sendRequest(data)),
    [dispatch]
  );

  const reset = useCallback(
    () => dispatch(forgotPasswordPageSlice.actions.reset()),
    [dispatch]
  );

  const {
    formState: { errors },
    register,
    handleSubmit,
  } = useForm<ForgotPasswordFormValues>();

  const onSubmit: SubmitHandler<ForgotPasswordFormValues> = (data) => {
    sendRequest(data);
  };

  useEffect(() => {
    if (requestSent) {
      navigate("/");
    }

    return () => {
      reset();
    };
  }, [navigate, requestSent, reset]);

  return (
    <Container fluid className={styles.container}>
      <Row className={styles.row}>
        <Form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
          <Image alt="logo" src={Logo} className={styles.logo} />

          <FloatingLabel controlId="email" label="Email address">
            <Form.Control
              type="email"
              placeholder="name@example.com"
              isInvalid={!!errors.email}
              {...register("email", {
                required: true,
              })}
              maxLength={100}
              disabled={isLoading}
            />
          </FloatingLabel>

          <Button
            type="submit"
            size="lg"
            className={styles.submit}
            disabled={isLoading}
          >
            Send reset link
            {isLoading && (
              <Spinner
                size="sm"
                animation="border"
                className={styles.spinner}
              />
            )}
          </Button>

          <div className={styles.goBack}>
            <Link to="/">Go back</Link>
          </div>

          <p className={styles.copyright}>
            © {moment().format("YYYY")} Girteka Competence Center
          </p>
        </Form>
      </Row>
    </Container>
  );
};

export default ForgotPasswordPage;
